// userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../../types";

interface UserState {
  isAuthenticated: boolean;
  user: any;
  userDetails: UserType | null;
  accessToken?: string;
  registerAsHost?: boolean;
}

const initialState: UserState = {
  isAuthenticated: false,
  user: null,
  userDetails: null,
  accessToken: undefined,
  registerAsHost: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    setUserDetails: (state, action: PayloadAction<any>) => {
      state.userDetails = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.accessToken = undefined;
      state.isAuthenticated = false;
      state.userDetails = null;
    },
    setRegisterAsHost: (state, action: PayloadAction<boolean>) => {
      state.registerAsHost = action.payload;
    },
  },
});

export const {
  setUser,
  setAccessToken,
  clearUser,
  setRegisterAsHost,
  setUserDetails,
} = userSlice.actions;
export default userSlice.reducer;
